module.exports = __webpack_public_path__ + "static/media/ic_hospicash_b2_fisdom.d14b96f3.svg";